import { BottomNavigation, BottomNavigationAction, Box, CssBaseline, Hidden, Icon, Menu, MenuItem, styled } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import AppSidebar from "../_components/sidebar/app.sidebar";
import { AppToolbar } from "../_components/toolbar/app.toolbar";
import { PRIMARY_COLOR, PRIMARY_COLOR_LIGHTER } from "../_const/color.const";
import { USER_NAV, ADMIN_NAV, PRIMARY_ORGANISER_NAV, PRIMARY_ADMIN_NAV } from "../_const/navigation.const";
import { accountService } from "../_services/accounts.service";
import AppUserSidebar from "../_components/sidebar/app.userSidebar";

const drawerWidth = 240;

const useStyles = {

    appScreen: {
        display: 'flex',
        backgroundColor: "#e6e6e6",
        height: "100%"
    },
    main: {
        marginTop: "40px"
    },
    root: {

    },
    mainBackground: {},
    stickToBottom: {
        width: '100%',
        position: 'fixed',
        bottom: 0,
        borderTop: '1px solid #e6e6e6',
        zIndex: 9999
    },
    toolbar: {},
};

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })<{
    open?: boolean;
}>(({ theme, open }) => ({
    flexGrow: 1,
    width: 'calc(100% - 500px)',
    maxWidth: "calc(100%)",
    paddingTop: theme.spacing(10),
    transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
    }),
}));


export function AppScreen() {
    const [value, setValue] = React.useState(0);
    const [isOpen, setIsOpen] = useState(false);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [anchorLicenses, setAnchorLicenses] = React.useState(null);

    let goTo = useNavigate();

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (e: any, nav: any) => {
        setAnchorEl(null);
        if (nav && nav.url)
            goTo(nav.url);
    };

    const handleCloseLicenses = (e: any, nav: any) => {
        setAnchorLicenses(null);
        goTo(nav);
    };

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    }


    return (
        <div style={useStyles.appScreen} id="app-screen">

            <AppToolbar toggleSidebar={toggleSidebar} isOpen={isOpen}></AppToolbar>

            {(accountService.isOrganiser || accountService.isAdmin) &&
                <Box display={{ xs: 'none', sm: 'none', md: 'block', lg: 'block', xl: 'block' }}>
                    <AppSidebar isOpen={true}></AppSidebar>
                </Box>
            }

            <Box display={{ xs: 'block', sm: 'block', md: 'none', lg: 'none', xl: 'none' }}>
                <AppUserSidebar isOpen={isOpen} setIsOpen={setIsOpen}></AppUserSidebar>
            </Box>

            <Main open={true} sx={{ marginBottom: "0px" }}>
                <Outlet></Outlet>
            </Main>

            {accountService.isAdmin &&
                <>
                    <Hidden mdUp>
                        <Box component="footer">
                            <BottomNavigation
                                value={value}
                                onChange={(event, newValue) => {
                                    setValue(newValue);
                                }}
                                showLabels={true}
                                sx={{
                                    position: 'fixed',
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    backgroundColor: '#fff',
                                    transition: 'transform 0.3s ease',
                                    zIndex: 99
                                }}>


                                {accountService.isAdmin && PRIMARY_ADMIN_NAV && PRIMARY_ADMIN_NAV.map((nav: any) =>
                                    <BottomNavigationAction key={"bottomNav_" + nav.name} onClick={() => goTo(nav.url)} label={nav.mobileName || nav.name} icon={
                                        <>
                                            {nav.png == null &&
                                                <Icon>{nav.icon}</Icon>
                                            }
                                        </>
                                    } />
                                )}

                                {accountService.isAdmin &&
                                    <BottomNavigationAction label={'Admin'} aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick} icon={
                                        <Icon>apps</Icon>
                                    } />
                                }

                                {accountService.isAdmin &&
                                    <Menu
                                        id="simple-menu"
                                        anchorEl={anchorEl}
                                        keepMounted
                                        open={Boolean(anchorEl)}
                                        onClose={handleClose}
                                    >

                                        {ADMIN_NAV && ADMIN_NAV.map(nav =>
                                            <MenuItem key={"sideNav_" + nav.name} onClick={(e: any) => handleClose(e, nav)}>{nav.name}</MenuItem>
                                        )}

                                    </Menu>
                                }


                                {(!accountService.isAdmin) &&
                                    <BottomNavigationAction label={'Licences'} aria-controls="simple-menu" aria-haspopup="true" onClick={(event: any) => { setAnchorLicenses(event.currentTarget) }} icon={
                                        <Icon>apps</Icon>
                                    } />
                                }

                                {(!accountService.isAdmin) &&
                                    <Menu
                                        id="simple-menu"
                                        anchorEl={anchorLicenses}
                                        keepMounted
                                        open={Boolean(anchorLicenses)}
                                        onClose={handleCloseLicenses}
                                    >

                                        <MenuItem onClick={(e: any) => { goTo("MotorLicences") }}>Competition</MenuItem>
                                        <MenuItem onClick={(e: any) => handleCloseLicenses(e, "OfficialLicences")}>Official</MenuItem>
                                        <MenuItem onClick={(e: any) => handleCloseLicenses(e, "Media")}>Media</MenuItem>
                                        <MenuItem onClick={(e: any) => handleCloseLicenses(e, "MinorEntrant")}>Minor Entrant</MenuItem>
                                        <MenuItem onClick={(e: any) => handleCloseLicenses(e, "OneDayEvent")}>One Event</MenuItem>

                                    </Menu>
                                }

                            </BottomNavigation>
                        </Box>
                    </Hidden>
                </>
            }

        </div >
    );
}